import { fromJS, Record } from 'immutable';
import { GeoipCity } from './sub-models/geoip-city.model';
import { GeoipCountry } from './sub-models/geoip-country.model';
import { generateKeys, generateSchema, setInModel } from 'i2g-ng-utils';

export const GEO_LOCATION_DATA_SCHEMA = Object.freeze({
  CITY: GeoipCity,
  COUNTRY: GeoipCountry,
});

const RECORD = generateSchema(GEO_LOCATION_DATA_SCHEMA);
const KEYS: any = generateKeys(GEO_LOCATION_DATA_SCHEMA);

export class GeoLocationData extends Record(RECORD) {
  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.CITY,
        value: new GeoipCity(this.city),
      },
      {
        key: KEYS.COUNTRY,
        value: new GeoipCountry(this.country),
      },
    ]);

    return selfModel as GeoLocationData;
  }

  get city(): GeoipCity {
    return this.get(KEYS.CITY);
  }

  get country(): GeoipCountry {
    return this.get(KEYS.COUNTRY);
  }
}
